/**
 * Handles /@:handle URLs (e.g. shxre.net/@news).
 * Fetches verified lookup from shxre.social API and redirects to /profile/{did}.
 * Falls back to /profile/{handle} if not found in verified DB.
 */

import {useEffect} from 'react'
import {View} from 'react-native'
import {type NativeStackScreenProps} from '@react-navigation/native-stack'

import {fetchVerifiedUser} from '#/lib/api/verified'
import {type CommonNavigatorParams} from '#/lib/routes/types'
import {navigate} from '#/Navigation'
import {atoms as a} from '#/alf'
import {LoadingPlaceholder} from '#/view/com/util/LoadingPlaceholder'

type Props = NativeStackScreenProps<
  CommonNavigatorParams,
  'AtHandleRedirect'
>

export function AtHandleRedirectScreen({route}: Props) {
  const handle = route.params.handle?.replace(/^@/, '') ?? ''

  useEffect(() => {
    if (!handle) {
      navigate('Home')
      return
    }

    let cancelled = false

    async function resolveAndRedirect() {
      try {
        const verified = await fetchVerifiedUser({handle})
        if (cancelled) return
        if (verified?.did) {
          navigate('Profile', {name: verified.did})
        } else {
          navigate('Profile', {name: handle})
        }
      } catch {
        if (cancelled) return
        navigate('Profile', {name: handle})
      }
    }

    resolveAndRedirect()
    return () => {
      cancelled = true
    }
  }, [handle])

  return (
    <View style={[a.flex_1, a.align_center, a.justify_center]}>
      <LoadingPlaceholder />
    </View>
  )
}
